import React from 'react';
import { splitTextWithLinks } from '../../../utils/crmChatLinkify';

export default function CrmChatMessageText({ body, isMine = false }) {
  const parts = splitTextWithLinks(body);

  return (
    <>
      {parts.map((part, i) => {
        if (part.type === 'link') {
          return (
            <a
              key={`l-${i}`}
              href={part.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`underline break-all ${
                isMine
                  ? 'text-white hover:text-emerald-50'
                  : 'text-emerald-700 hover:text-emerald-800 dark:text-emerald-400'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {part.value}
            </a>
          );
        }
        return <React.Fragment key={`t-${i}`}>{part.value}</React.Fragment>;
      })}
    </>
  );
}
